import * as React from "react";

const SvgIcnOpen = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                d="M12.5 5a.5.5 0 110 1h-6a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-6a.5.5 0 111 0v6a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 015 17.5v-11A1.5 1.5 0 016.5 5h6zm8-2a.5.5 0 01.5.5v6a.5.5 0 11-1 0V4.706l-8.146 8.148a.5.5 0 01-.708-.708L19.292 4H14.5a.5.5 0 110-1h6z"
                id="IcnOpen_svg__a"
            />
        </defs>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <use fill="#ABABAB" xlinkHref="#IcnOpen_svg__a" />
            <use fillOpacity={0.8} fill="currentColor" xlinkHref="#IcnOpen_svg__a" />
        </g>
    </svg>
);

export default SvgIcnOpen;
